import React from 'react';
import { useForm } from 'react-hook-form';
import styles from './index.module.scss';
import DraggableDialog from '@components-clean/core/draggable-dialog';
import { TextAreaController } from '@components-clean/core/text-area';
import { useTranslation } from '@hooks/index';

const HEIGHT = 300;
const WIDTH = 600;

type Props = {
    title?: string;
    reasonFieldLabel?: string;
    maxLength: number;
    onCancel: () => void;
    onSubmit: (reason: string) => unknown;
};

const ReasonForChangeDialog = ({ title, reasonFieldLabel, maxLength, onCancel, onSubmit }: Props) => {
    const { t } = useTranslation();

    const {
        control,
        handleSubmit,
        formState: { isValid, isSubmitting, isDirty },
    } = useForm({
        mode: 'all',
        defaultValues: {
            reason: '',
        },
    });

    const submitDisabled = !isValid || isSubmitting || !isDirty;

    const resolvedHandleSubmit = handleSubmit(async (values) => {
        await onSubmit(values.reason);
    }) as () => unknown;

    return (
        <DraggableDialog
            dataTestId="reason-for-change-dialog"
            title={title ?? t('common:reasonForChange')}
            primaryBtnDisabled={submitDisabled}
            width={WIDTH}
            height={HEIGHT}
            onSubmit={resolvedHandleSubmit}
            onClose={onCancel}
        >
            <div className={styles.dialogInner}>
                <TextAreaController
                    data-testid="reason-for-change-textarea"
                    className={styles.reasonTextarea}
                    control={control}
                    name="reason"
                    maxLength={maxLength}
                    required
                    label={reasonFieldLabel ?? t('common:reasonForChange')}
                    validateRules={{
                        required: (value) => {
                            if (typeof value !== 'string' || value.trim().length === 0) {
                                return t('ra:requiredFieldError');
                            }
                            return true;
                        },
                    }}
                />
            </div>
        </DraggableDialog>
    );
};

export default ReasonForChangeDialog;
